import createTransition from 'shared-tokens/utils/createTransition';
import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brpM = createBreakpoint('m');
export const mainCls = 'accordion-item-shared';
export default {
  [mainCls]: {

  },
  [`${mainCls}__head`]: {
    [brpM]: {
    },
  },

  [`${mainCls}__icon`]: {
  },

  [`${mainCls}__body`]: {
    overflow: 'hidden',
  },

  [`${mainCls}__body--anim`]: {
    transition: `${createTransition(['max-height'], { type: '' })} cubic-bezier(.4, 0, 0.2, 1)`,
  },

  [`${mainCls}__children`]: {
  },

  [`${mainCls}:hover`]: {
    [`${mainCls}__icon`]: {
    },
  },
};
